import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { cx } from '../utils/cx';

export interface IconButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'children'
> {
  /** Nom accessible obligatoire : le bouton n'a pas de texte visible. */
  label: string;
  children: ReactNode;
  variant?: 'plain' | 'filled' | 'danger';
  size?: 'md' | 'lg';
  /**
   * Bouton bascule (micro, caméra) : `true` = actif. L'état est aussi porté par l'icône
   * (barrée quand coupée), jamais par la couleur seule.
   */
  pressed?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

export function IconButton({
  label,
  children,
  variant = 'plain',
  size = 'md',
  pressed,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      aria-pressed={pressed}
      className={cx(
        'av-icon-button',
        variant !== 'plain' && `av-icon-button--${variant}`,
        size === 'lg' && 'av-icon-button--lg',
        pressed !== undefined && 'av-icon-button--toggle',
        className,
      )}
      {...rest}
    >
      <span className="av-icon" aria-hidden="true">
        {children}
      </span>
    </button>
  );
}
